import type { Control, FieldValue, FieldValues } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import type { InputChipsProps } from './InputChips'
import InputChips from './InputChips'

interface HFInputChipsProps extends InputChipsProps {
  name: string
  control: Control<FieldValue<FieldValues>>
}

function HFInputChips({ name, control, onChange, required, ...rest }: HFInputChipsProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <div className='field'>
            <InputChips
              {...rest}
              values={field.value}
              onChange={values => {
                field.onChange(values)
                onChange(values)
              }}
              required={required}
              error={fieldState.invalid}
            />
            {required && fieldState.invalid && (
              <p className='error-label'>
                {Array.isArray(fieldState.error) ? 'One of the Emails are not valid' : fieldState.error?.message}
              </p>
            )}
          </div>
        )
      }}
    />
  )
}

export default HFInputChips
